import React, {useContext, useEffect, useState} from 'react';
import {ID, KTSVG} from "../../../../_metronic/helpers";
import {generateQuery} from "../../disk/_core/_helper";
import {GetTicket} from "../core/_requests";
import Swal from "sweetalert2";
import {ticketStatus} from "../core/_model";
import {TicketContext} from "../core/TicketContext";


const TicketList = () => {
    const {Tickets , setTickets ,listQueryRequest ,setListQueryRequest,setItemIdForUpdate,itemIdForUpdate} = useContext(TicketContext)
    const [loading, setLoading] = useState(false);
    const [searchItem , setSearchItem] =useState('')
    const bindTicketFromServer = async (isLoaded : boolean , query? : any   ) =>{
        try {
            setLoading(true);
            const {data:response} = await GetTicket(query ? query : generateQuery(listQueryRequest));
            if(isLoaded == true){
                setTickets(response.data || [] )
            }else {
                let newList = Tickets.concat(response.data || []) ;
                setTickets(newList)
            }
            setListQueryRequest({...query , page: response.payload?.pagination?.page || 1 ,last_page:response.payload?.pagination?.last_page || 1 ,total:  response.payload?.pagination?.total || 0})
            Swal.close()
        }
        catch (err:any){
            Swal.close()
            Swal.fire({
                title:'خطا',
                text : err.response?.data?.message || err ,
                icon : 'error',
                confirmButtonText : 'تایید'
            })
        }finally {
            setLoading(false)
        }
    }
    useEffect(()=>{
        bindTicketFromServer(true);
    },[])
    const handleScroll =(e: any)=>{
        const bottom = Math.floor(e.target.scrollHeight - e.target.scrollTop) <= e.target.clientHeight;

        if (bottom) {
            console.log('sum:' + (e.target.scrollHeight - e.target.scrollTop )+ '- '+e.target.clientHeight)
            if (listQueryRequest.last_page !== listQueryRequest.page){

                const query = {...listQueryRequest,page :listQueryRequest.page +1 , search:searchItem ,items_per_page: 10  } ;
                bindTicketFromServer(false,generateQuery(query));
            }
        }
    }
    const SearchTerm = (search : any)=>{
        setSearchItem(search.target.value);
        const query = {...listQueryRequest, search:search.target.value ,items_per_page: 10  } ;
        bindTicketFromServer(true,generateQuery(query));
    }

    return (
        <div className='flex-column flex-lg-row-auto w-100 w-lg-300px w-xl-400px mb-10 mb-lg-0'>
            <div className='card card-flush'>
                <div className='card-header pt-7' id='kt_chat_contacts_header'>
                    <form className='w-100 position-relative' autoComplete='off'>
                        <KTSVG
                            path='/media/icons/duotune/general/gen021.svg'
                            className='svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 position-absolute top-50 ms-5 translate-middle-y'
                        />

                        <input
                            value={searchItem}
                            onInput={SearchTerm}
                            type='text'
                            className='form-control form-control-solid px-15'
                            name='search'
                            placeholder='جستجو در تیکت ها '
                        />
                    </form>
                </div>

                <div className='card-body pt-5' id='kt_chat_contacts_body'>
                    <div
                        className='scroll-y me-n5 pe-5 h-200px h-lg-auto'
                        data-kt-scroll='true'
                        onScroll={handleScroll}
                        data-kt-scroll-activate='{default: false, lg: true}'
                        data-kt-scroll-max-height='auto'
                        data-kt-scroll-dependencies='#kt_header, #kt_toolbar, #kt_footer, #kt_chat_contacts_header'
                        data-kt-scroll-wrappers='#kt_content, #kt_chat_contacts_body'
                        data-kt-scroll-offset='0px'
                    >
                        {Tickets.map((item,index)=>(
                            <div key={`ticket-${index}`}>
                                <div  className={`rounded p-2 d-flex flex-stack  py-4 bg-active-light ${item.id ==itemIdForUpdate?.id && 'active' }`}>
                                    <div className='d-flex align-items-center'>
                                        <div className='symbol symbol-45px symbol-circle'>
                    <span className='symbol-label bg-light-danger text-danger fs-6 fw-bold'>
                      {item.ticketStatus == ticketStatus.IsClosed ?'بسته' : 'باز'}
                    </span>
                                        </div>

                                        <div className='ms-5'>
                                            <a onClick={()=>{
                                                setItemIdForUpdate(item)
                                            }} className=' cursor-pointer fs-5 fw-bold text-gray-900 text-hover-primary mb-2'>
                                                {item.title}
                                            </a>
                                            {item.ticketStatus?.toString() === 'IsPending' ? (
                                                    <div className="fw-semibold">
                                                        <span className=" badge badge-warning">{item.ticketStatusString}</span>

                                                    </div>
                                                ):
                                                item.ticketStatus?.toString() === 'IsClosed' ? (
                                                        <div className="fw-semibold">
                                                            <span className="badge badge-success">{item.ticketStatusString}</span>

                                                        </div>
                                                    ):
                                                    item.ticketStatus?.toString() === 'AdminIsResponse' ? (
                                                            <div className="fw-semibold">
                                                                <span className="badge badge-info">{item.ticketStatusString}</span>

                                                            </div>
                                                        ):
                                                        <div className="fw-semibold">
                                                            <span className="badge badge-secondary">{item.ticketStatusString}</span>

                                                        </div>
                                            }
                                        </div>
                                    </div>

                                    <div className='d-flex flex-column align-items-end ms-2'>
                                        <span className='text-muted fs-7 mb-1'>{item.dataModifiedstring}</span>
                                    </div>
                                </div>

                                <div className='separator separator-dashed d-none'></div>
                            </div>
                        ))}

                    </div>
                </div>
            </div>
        </div>

    );
};

export default TicketList;